module.exports = __webpack_public_path__ + "img/pencil-filter-right_en.c903762.jpg";